// const env = 'dev'
const env = 'prod'
export const baseUrl = env === 'dev' ? 'https://cim-back.pm.sirun.net/' : 'https://cim-back.pm.sirun.net/'
